import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'core/context/AuthContext/AuthContextProvider';
import { DigitalMarketingBreadcrumb } from 'features/DigitalMarketing/components/DigitalMarketingBreadcrumb';
import { WEBSITE_CONTENT_SECTIONS } from 'features/DigitalMarketing/routes/editWebsiteContentRoutes';
import { DMButton, DMDiv, DMText } from '../../components/Primitives';

export function EditWebsiteContent() {
  const navigate = useNavigate();
  const authData = useAuth();
  const websiteUrl = authData?.BRANCH_DOMAIN
    ? `https://${authData.BRANCH_DOMAIN}/`
    : undefined;

  const handleVisitWebsite = () => {
    if (websiteUrl) {
      window.open(websiteUrl, '_blank');
    }
  };

  const handleEditSection = (path: string) => {
    navigate(path);
  };

  return (
    <DMDiv
      as="main"
      className="min-h-full bg-white px-[2.8vw] py-[1.8vh] font-inter text-gray-900"
    >
      <DMDiv className="mb-[4.5vh] flex items-start justify-between gap-[2vw]">
        <DMDiv>
          <DigitalMarketingBreadcrumb
            className="mb-[2.2vh]"
            items={[{ label: 'Edit Website Content' }]}
          />

          <DMText
            as="h1"
            className="text-[3.8vh] font-bold leading-tight text-gray-900"
          >
            Edit Website Content
          </DMText>
          <DMText className="mt-[0.5vh] text-[1.9vh] leading-tight text-gray-600">
            Manage your school&apos;s online presence - Control how parents see
            your institution
          </DMText>
        </DMDiv>

        <DMButton
          type="button"
          onClick={handleVisitWebsite}
          disabled={!websiteUrl}
          className="mt-[3vh] rounded-full border border-primary-main px-[1.6vw] py-[1.5vh] text-[1.7vh] font-medium leading-none text-primary-main transition-colors hover:bg-primary-10 disabled:cursor-not-allowed disabled:opacity-50"
        >
          Visit Website
        </DMButton>
      </DMDiv>

      <DMDiv
        as="section"
        className="mx-auto grid max-w-[90vw] grid-cols-1 gap-[1vh] md:grid-cols-2 md:gap-x-[0.6vw] md:gap-y-[1vh]"
      >
        {WEBSITE_CONTENT_SECTIONS.map(item => {
          const Icon = item.icon;

          return (
            <DMDiv
              as="article"
              key={item.title}
              className="relative min-h-[17.2vh] rounded-[8px] border border-gray-200 bg-white px-[1.5vw] py-[2.4vh] shadow-[0_1px_2px_rgba(0,0,0,0.03)]"
            >
              <Icon
                className="mb-[2.2vh] h-[3.8vh] w-[3.8vh] text-primary-main"
                strokeWidth={2.2}
              />

              <DMDiv className="pr-[8vw]">
                <DMText
                  as="h2"
                  className="text-[2vh] font-bold leading-tight text-gray-900"
                >
                  {item.title}
                </DMText>
                <DMText className="mt-[1.4vh] text-[1.65vh] font-medium leading-snug text-gray-600">
                  {item.description}
                </DMText>
              </DMDiv>

              <DMButton
                type="button"
                onClick={() => handleEditSection(item.path)}
                className="absolute right-[1.5vw] top-[2.4vh] rounded-full bg-primary-main px-[1.4vw] py-[1.2vh] text-[1.55vh] font-semibold leading-none text-white shadow-sm transition-opacity hover:opacity-90"
              >
                Edit
              </DMButton>
            </DMDiv>
          );
        })}
      </DMDiv>
    </DMDiv>
  );
}
